"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Components = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _constant = require("../../styles/constant");
var _Input = _interopRequireDefault(require("../Input"));
var _FormElements = require("../../styles/FormElements");
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
const variants = {
  inputFit: _FormElements.inputFit,
  inputVariant: _FormElements.inputVariant,
  inputErrorFocusVariant: _FormElements.inputErrorFocusVariant,
  inputFocusVariant: _FormElements.inputFocusVariant,
  paddingVariant: _FormElements.paddingVariant
};
const Wrapper = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  position: relative;\n  display: flex;\n  flex: 1 1 100%;\n  ", "\n  ", "\n  ", "\n  padding: 0;\n  border-color: ", ";\n  overflow: hidden;\n"])), variants.inputFit, variants.inputVariant, _FormElements.BasicInputStyle, props => props.error ? (0, _constant.get)('colors.feedback.danger.normal') : (0, _constant.get)('colors.functional.grey.400'));
const AppendGroup = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])([""])));
const PrependGroup = _styledComponents["default"].div(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])([""])));
const InputElement = (0, _styledComponents["default"])(_Input["default"])(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n  border: 0;\n\n  &:focus {\n    outline: 0;\n    box-shadow: none;\n  }\n"])));
const Components = exports.Components = {
  AppendGroup,
  InputElement,
  PrependGroup,
  Wrapper
};